import { useBinaryStateMachine } from "../../common/useBinaryStateMachine";

export const useDelayedProgressIndicator = ({ isRemoving }) => {
  const [isInProgress, setInProgress] = useBinaryStateMachine({
    ambientState: isRemoving
  });

  return { isInProgress, setInProgress };
};
